/** Regras puras do Kanban O.S.; a autorização definitiva permanece nas RPCs. */
export const SERVICE_ORDER_KANBAN_PAGE_SIZE = 5;

export function resolveServiceOrderCategory(requested: string | null, categories: { id: string; is_default?: boolean }[]) {
  return categories.find(c => c.id === requested)?.id ?? categories.find(c => c.is_default)?.id ?? categories[0]?.id ?? null;
}

/** Origem e destino precisam autorizar a movimentação, além do menu e da situação. */
export function canMoveServiceOrder(menuAllowed: boolean, status: string, sourceAllowed: boolean, targetAllowed = true) {
  return menuAllowed && status !== 'completed' && status !== 'cancelled' && sourceAllowed && targetAllowed;
}